/*** IMPORTS FROM imports-loader ***/
var define = false;

/*jslint todo: true */
"use strict";

// Display busy indicator dialog (and an
// eventual error, if any) on any form.

var ko = require("knockout");
require("knockout-postbox");

var pli = require("../forms");


// TODO: Refactor this so that it can be used outside of forms
//  -> Allow methods to accept 'form' as a parameter (defaults to busyIndicatorForm)
//  -> Accept 'form' in BusyIndicatorViewModel constructor, pass to open|close|complete

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// BusyIndicatorViewModel class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
// View-model object for busy indicator dialog
// (must be instantiated using 'new').
function BusyIndicatorViewModel() {
    this.state = ko.observable("init").subscribeTo("state", true); // true => initializeWithLatestValue
    this.completed = ko.observable(0); // 0 for not completed, 1 for completed successfully, 2 for completed with failure
    this.message = ko.observable("");
    this.title = ko.observable("");
    this.icon = ko.observable("sprite-save-16");
    this.closeFocused = ko.observable(false);
    this.onClosed = [];
}



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Local
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

var busyIndicatorForm; // shortcut for Pli.forms.registry.busyIndicator


//-------------------------------------------
function closeBusyIndicator(options) {
    /// <summary>
    /// Close busy form using the specified options
    /// (dialog is hidden). If open/complete method
    /// specified an options.onClosed function,
    /// it will be called now (after the form
    /// is closed successfully).
    /// </summary>
    /// <param name="options">
    /// A JavaScript object (set of key/value pairs)
    /// that configures close behaviour.
    /// <para>force (optional) - Flag indicating
    /// whether close should be forced. If false,
    /// close calls will be ignored if complete
    /// was not called first. If not specified,
    /// defaults to false.</para>
    /// <para>state (optional) - State to publish
    /// to "state" postbox topic as soon as the
    /// dialog is closed. If not specified,
    /// defaults to state that was active
    /// when open method was called
    /// (restores original state).</para>
    /// </param>
    var i, l, m = busyIndicatorForm.viewModel;
    if (!m || !m.stateOnOpen) { return false; } // reject calls on inactive busy indicator

    if (!options) { options = {}; }
    if (!m.completed() && !options.force) { return false; } // reject calls if incomplete

    pli.forms.close("busyIndicator");
    ko.postbox.publish("state", options.state || m.stateOnOpen);
    delete m.stateOnOpen;
    if (m.onClosed.length) {
        for (i = 0, l = m.onClosed.length; i < l; i += 1) {
            m.onClosed[i].call(busyIndicatorForm);
        }
        m.onClosed.length = 0;
    }

    return false;
}


//-------------------------------------------
function completeBusyIndicator(options) {
    /// <summary>
    /// Switch busy form to 'succeeded' or 'failed'
    /// mode (still visible, but shows status
    /// bar with caller-specified message;
    /// user must dismiss the dialog by clicking
    /// close button or pressing ESC key).
    /// </summary>
    /// <param name="options">
    /// A JavaScript object (set of key/value pairs)
    /// that configures complete behaviour.
    /// <para>failed (optional) - Flag indicating
    /// whether operation failed (true) or
    /// succeeded (false). If not specified,
    /// defaults to false (i.e. assumes operation
    /// succeeded).</para>
    /// <para>message (optional) - Message to show
    /// in dialog content area. If not specified,
    /// defaults to either "Unspecified error" or
    /// "Completed successfully" depending
    /// on options.failed value.</para>
    /// <para>title (optional) - Title of dialog
    /// that will be shown. If not specified,
    /// defaults to either "Operation failed" or
    /// "Operation succeeded" depending
    /// on options.failed value.</para>
    /// <para>state (optional) - State to publish
    /// to "state" postbox topic. If not specified,
    /// defaults to either "busy.fail" or "busy.done"
    /// depending on options.failed value.</para>
    /// <para>onClosed (optional) - Function to call
    /// when the dialog is closed.</para>
    /// </param>
    var success, m = busyIndicatorForm.viewModel;
    if (!m || !m.stateOnOpen) { return false; } // reject calls on inactive busy indicator

    if (!options) { options = {}; }

    success = !options.failed;
    m.completed(success ? 1 : 2);
    m.title(options.title || (success ? "Operation succeeded" : "Operation failed"));
    m.message(options.message || (success ? "Completed successfully" : "Unspecified error"));
    ko.postbox.publish("state", options.state || (success ? "busy.done" : "busy.fail"));
    m.closeFocused(true);
    if (typeof options.onClosed === "function") {
        m.onClosed.push(options.onClosed);
    }
    return false;
}


//-------------------------------------------
function openBusyIndicator(options) {
    /// <summary>
    /// Show busy form using the specified options.
    /// (dialog is shown).
    /// </summary>
    /// <param name="options">
    /// A JavaScript object (set of key/value pairs)
    /// that configures open behaviour.
    /// <para>message (optional) - Message to show
    /// in dialog content area. If not specified,
    /// defaults to "Please wait...".</para>
    /// <para>title (optional) - Title of dialog
    /// that will be shown. If not specified,
    /// defaults to "Operation in progress".</para>
    /// <para>icon (optional) - Icon next to title
    /// of dialog that will be shown. If not specified,
    /// defaults to "sprite-save-16".</para>
    /// <para>state (optional) - State to publish
    /// to "state" postbox topic as soon as the
    /// dialog is shown. If not specified,
    /// defaults to "busy".</para>
    /// <para>onClosed (optional) - Function to call
    /// when the dialog is closed.</para>
    /// </param>
    if (!options) { options = {}; }

    var m = busyIndicatorForm.viewModel;
    if (!m) {
        BusyIndicatorViewModel.prototype.close = closeBusyIndicator;
        busyIndicatorForm.viewModel = m = new BusyIndicatorViewModel();
        ko.applyBindings(m, busyIndicatorForm.$form[0]);
    }

    m.completed(0);
    m.icon(options.icon || "sprite-save-16");
    m.title(options.title || "Operation in progress");
    m.message(options.message || "Please wait...");
    m.stateOnOpen = m.state();
    ko.postbox.publish("state", options.state || "busy");
    if (typeof options.onClosed === "function") {
        m.onClosed.push(options.onClosed);
    }
    pli.forms.open("busyIndicator", {});

    return false;
}



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// define API
busyIndicatorForm = pli.forms.registry.busyIndicator;
busyIndicatorForm.close = closeBusyIndicator;
busyIndicatorForm.complete = completeBusyIndicator;
busyIndicatorForm.open = openBusyIndicator;

// configure keyboard
busyIndicatorForm.page.keymap = "busyIndicator";
pli.keys.registerKeymap("busyIndicator", {
    "esc": closeBusyIndicator
});

module.exports = busyIndicatorForm;




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms-busyindicator/BusyIndicator.js
// module id = 500
// module chunks = 49